import { useMemo } from "react";

import { Column } from "@covertree/ui/table/types";

import { RenewalFilterByStatus } from "@covertree/agent-portal-graphql";

import {
  RemovableRenewalColumn,
  allRenewalsColumns,
  getColumnsToRemove,
} from "./utils";

export const useGetRenewalsColumns = (
  filter: RenewalFilterByStatus
): Column[] => {
  return useMemo(() => {
    const columnsToRemove = getColumnsToRemove(filter);

    return allRenewalsColumns.filter(
      ({ headerName }) =>
        !columnsToRemove.includes(headerName as RemovableRenewalColumn)
    );
  }, [filter]);
};
